export const POST_CUSTOM_CHART_MOCK = {
  status: 'ok',
  chart_id: 1
}